import { makeStyles } from "@mui/styles";
import React from "react";
import Appbar from "../component/Appbar/Appbar";
import Layout from "../component/Layout/Layout";
import ParticalesBackground from "../component/Particales/ParticalesBackground";
import Header from "./Header";
const useStyles = makeStyles(() => ({
  root: {
    // backgroundColor: '#250647',
    // // clipPath: 'polygon(0 0, 100% 0, 100% 69%, 66% 75%, 33% 69%, 0 75%)',
    // // height: '400px'
    // // clipPath: 'polygon(20% 0%, 100% 0, 100% 83%, 69% 79%, 28% 89%, 0% 80%, 0 0)',
    // clipPath: 'polygon(0 0, 100% 0, 100% 96%, 56% 92%, 24% 98%, 0 89%, 0 33%)',
    // padding: '10px 0'
  },
  particle: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: '-1'
  }
}))
export default function Home() {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Appbar />
      <div className={classes.particle}>
        <ParticalesBackground />
      </div>

      <Layout>
        <Header />
      </Layout>
    </div>
  );
}
